import Swiper from "swiper";

const sliderContainer = document.querySelector('.modal-land-area__slider')

if (sliderContainer) {
    const slider = new Swiper(sliderContainer, {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.modal-land-area .swiper-pagination',
            type: 'fraction',
        },
        navigation: {
            nextEl: '.modal-land-area__slider-next',
            prevEl: '.modal-land-area__slider-prev',
        },
    })

    sliderContainer.slider = slider
}